<template>
  <div>
    <v-layout wrap justify-center>
      <v-flex xs12 px-0 px-sm-4 pt-4>
        <v-layout wrap justify-center>
          <v-flex xs10 sm12 xl12 text-left text-uppercase>
            <span
              style="
                font-family: poppinssemibold;
                font-size: 16px;
                color: #000000;
                letter-spacing: 1px;
              "
            >
              Profile Details
            </span>
          </v-flex>
        </v-layout>
        <v-layout wrap justify-start pt-4>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 14px;
                    color: #8e8e8e;
                  "
                >
                  Email
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ userDetails.email}}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 14px;
                    color: #8e8e8e;
                  "
                >
                  User Type
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                {{userType}}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <!-- <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 14px;
                    color: #8e8e8e;
                  "
                >
                  Email ID
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ appUser.email }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex xs10 sm6 md6 lg6 xl6 text-center py-6>
            <v-layout wrap justify-center>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 14px;
                    color: #8e8e8e;
                  "
                >
                  Gender
                </span>
              </v-flex>
              <v-flex xs12 text-left>
                <span
                  style="
                    font-family: kumbhsansregular;
                    font-size: 16px;
                    color: #000000;
                  "
                >
                  {{ appUser.gender }}
                </span>
              </v-flex>
            </v-layout>
          </v-flex> -->
        </v-layout>
      </v-flex>
    </v-layout>
    
  </div>
</template>
<script>
import axios from 'axios'
export default {
  data(){
    return{
      userDetails:[],
      userType:null,
    }
  },
  beforeMount(){
    this.getProfile()
  },
  methods:{
    getProfile(){
      axios({
        method:'GET',
        url:'/admin/me',
        headers:{
          'token': localStorage.getItem('token'),
        },

      })
      .then((response) =>{
        if(response.data.status){
          this.userDetails=response.data.data;
          console.log(this.userDetails)
          if(this.userDetails.usertype==0){
            this.userType="Admin";
          }
        }
      }) .catch((err) => {
          console.log(err);
        });
    }
  }
}
</script>